import {Component, Input, OnDestroy} from '@angular/core';

@Component({
    selector: 'my-spinner',
    //templateUrl: 'app/components/spinner/spinner.html'
    template: `
    <div  *ngIf="!isRunning" class="spinnercontainer">
        <div class="spinner"> 
        <i class="fa fa-spinner fa-spin loading-icon"></i> 
        <!--div>
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div-->
        <h2 style="margin-top:20px;">Procesando</h2> 
        <p>{{mensaje}}</p>   
        </div>
    </div>  
    `,
    styleUrls:['./spinner.component.css']
})
export class SpinnerComponent implements OnDestroy {  
    private currentTimeout: any;
    private isDelayedRunning: boolean = false;
    @Input()
    public mensaje: string = "";
    @Input()
    public delay: number = 300;

    @Input()
    public isRunning: boolean = false;
    /*
    @Input()
    public set isRunning(value: boolean) {
        console.log(value);
        if (!value) {
            this.cancelTimeout();
            this.isDelayedRunning = false;
        }

        if (this.currentTimeout) {
            return;
        }

        this.currentTimeout = setTimeout(() => {
            this.isDelayedRunning = value;
            this.cancelTimeout();
        }, this.delay);
    }*/
    private cancelTimeout(): void {
        clearTimeout(this.currentTimeout);
        this.currentTimeout = undefined;
    }

    ngOnDestroy(): any {
        this.cancelTimeout();
    }
}


// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/components/spinner/spinner.component.ts